import type { RootState } from "../store";
import { BoutiqueItem } from "./types";

export const selectBoutiqueList = (state: RootState): BoutiqueItem[] =>
  state.Boutique?.list ?? [];

export const selectSelectedBoutiqueId = (state: RootState): string | null =>
  state.Boutique?.selectedBoutiqueId ?? null;

export const selectSelectedBoutique = (state: RootState): BoutiqueItem | null => {
  const id = state.Boutique?.selectedBoutiqueId;
  if (!id) return null;
  return state.Boutique?.list?.find((b) => b.id === id) ?? null;
};

export const selectBoutiquesLoading = (state: RootState): boolean =>
  !!state.Boutique?.loading;

export const selectBoutiquesLoaded = (state: RootState): boolean =>
  !!state.Boutique?.loaded;

export const selectBoutiquesError = (state: RootState): string | null =>
  state.Boutique?.error ?? null;
